import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
import GraphqlApi from '../../api-graphql';
import Tags from '../Tags';

const useStyles = makeStyles((theme) => ({
  middleContainer: {
    width: '100%',
    display: 'flex',
    flesDirection: 'row',
    justifyContent: 'space-between'
  },
  button: {
    margin: 5
  },
  stepperRoot: {
    backgroundColor: theme.palette.background.default
  },
  accordionRoot: {
    width: 400,
    boxShadow: 'none',
    border: 'none',
    background: theme.palette.background.default
  },
  accordionDetail: {
    display: 'block'
  },
  itemText: {
    display: 'flex',
    flexDirection: 'row'
  },
  titleText: {
    fontWeight: 'bold'
  },
  buttonsBlock: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
  }
}));

const DocumentDetails = (props) => {
  const { item, appConfig } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const { enableTags } = appConfig;

  return (
    <>
      <div className={classes.itemText}>
        <Typography variant='body1' className={classes.titleText}>{t('processDetail:name')}&nbsp;</Typography>
        <Typography variant='body1'>{item.name}</Typography>
      </div>
      <div className={classes.itemText}>
        <Typography variant='body1' className={classes.titleText}>{t('processDetail:description')}&nbsp;</Typography>
        <Typography variant='body1'>{item.description}</Typography>
      </div>
      <div className={classes.itemText}>
        <Typography variant='body1' className={classes.titleText}>{t('processDetail:status')}&nbsp;</Typography>
        <Typography variant='body1'>{t(`processDetail:${item.status}`)}</Typography>
      </div>
      {item.annexes && <div className={classes.itemText}>
        <Typography variant='body1' className={classes.titleText}>{t('processDetail:documentsNumber')}&nbsp;</Typography>
        <Typography variant='body1'>{item.annexes.length + 1}</Typography>
      </div>}
      {item.template && <div className={classes.itemText}>
        <Typography variant='body1' className={classes.titleText}>{t('processDetail:template')}&nbsp;</Typography>
        <Typography variant='body1'>{item.template.name}</Typography>
      </div>}
      <div className={classes.itemText}>
        <Typography variant='body1' className={classes.titleText}>{t('processDetail:documentID')}&nbsp;</Typography>
        <Typography variant='body1'>{item.id}</Typography>
      </div>
      <div className={classes.itemText}>
        <Typography variant='body1' className={classes.titleText}>{t('processDetail:lastUpdate')}&nbsp;</Typography>
        <Typography variant='body1'><Moment format='DD/MM/YYYY HH:mm:ss'>{item.updatedAt}</Moment></Typography>
      </div>
      {enableTags &&
      <div className={classes.itemText}>
        <Typography variant='body1' className={classes.titleText}>{t('processDetail:tags')}&nbsp;</Typography>
        <Tags item={item} update={GraphqlApi.updateDocument} />
      </div>
      }
    </>
  );
};

export default DocumentDetails;
